import React from 'react'

function TenderTextPuri() {
  return (
    <embed src="\pdfs\E1.5.2_puri-drall-pdk_puri-clean-pck_puri-inlet-pek_01.2013-kr.pdf" width="100%" height="2100px" />
  )
}

export default TenderTextPuri